import { UserActions } from 'actions/actionTypes';

interface IAgenticWidgetUsageState {
  /** Pauses (-1) and resumes (+1) the fetched count does not include yet. */
  usedDelta: number;
  /**
   * A toggle the fetched count does not include yet. Kept apart from
   * `usedDelta` because a pause and a resume can sum to zero while the server
   * count still moved (one of the widgets may not be counted).
   */
  isEstimate: boolean;
  /** Toggles made since the latest `features_and_limits` request started. */
  deltaSinceRequest: number;
  changedSinceRequest: boolean;
}

const initialState: IAgenticWidgetUsageState = {
  usedDelta: 0,
  isEstimate: false,
  deltaSinceRequest: 0,
  changedSinceRequest: false
};

// Kept out of `state.user` on purpose: many components subscribe to the whole
// user object, so writing a pause into it re-rendered the entire page.
const agenticWidgetUsage = (
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state = initialState,
  action: { type: string; delta?: number }
): IAgenticWidgetUsageState => {
  switch (action.type) {
    case UserActions.ADJUST_AGENTIC_WIDGET_USAGE: {
      const delta = action.delta ?? 0;
      return {
        usedDelta: state.usedDelta + delta,
        isEstimate: true,
        deltaSinceRequest: state.deltaSinceRequest + delta,
        changedSinceRequest: true
      };
    }
    case UserActions.FETCH_USER_SUBSCRIPTION_LIMITS_REQUEST:
      return state.changedSinceRequest
        ? { ...state, deltaSinceRequest: 0, changedSinceRequest: false }
        : state;
    // The fetched count includes every toggle made before its request started,
    // but not the ones made while it was in flight.
    case UserActions.FETCH_USER_SUBSCRIPTION_LIMITS_SUCCESS:
      if (!state.isEstimate && !state.changedSinceRequest) {
        return state;
      }
      return {
        usedDelta: state.deltaSinceRequest,
        isEstimate: state.changedSinceRequest,
        deltaSinceRequest: 0,
        changedSinceRequest: false
      };
    default:
      return state;
  }
};

export default agenticWidgetUsage;
